module.exports = __webpack_public_path__ + "img/profile_sp.47de6088.jpg";